export default "__VITE_ASSET__Byo68fSi__"